import styled, { css } from 'styled-components';
import { rem } from 'polished';

const StyledTooltipBasic = styled.div`
  position: absolute;
  bottom: ${rem('-35px')};
  left: ${rem('-29px')};
  background-color: #000;
  color: #fff;
  padding: ${rem('6px')} ${rem('7px')};
  width: ${rem('145px')};

  &:before {
    content: '';
    width: 0;
    height: 0;
    border-bottom: ${rem('10px')} solid #000;
    border-left: ${rem('8px')} solid transparent;
    border-right: ${rem('8px')} solid transparent;
    position: absolute;
    top: ${rem('-7px')};
    left: ${rem('32px')};
  }

  p {
    margin-bottom: 0;
    font-size: ${rem('14px')};
    font-family: ${props => props.theme.fonts.medium};
  }
`;

const StyledTooltip = styled.div`
  position: relative;

  & ${StyledTooltipBasic} {
    ${props =>
      props.active
        ? css`
            display: block;
          `
        : css`
            display: none;
          `};
  }
`;

// Capa del Tooltip
const StyledTooltipAdvanced = styled.span`
  background-color: #25396e;
  box-shadow: 0 2px 4px 0 rgba(25, 25, 25, 0.41);
  color: ${props => props.theme.colors.light};
  font-family: ${props => props.theme.fonts.semiBold};
  font-size: ${rem('14px')};
  opacity: 0;
  padding: ${rem('5px')} ${rem('20px')};
  position: absolute;
  transition: opacity 0.3s;
  visibility: hidden;
  white-space: normal;
  z-index: 1;
  :after {
    border-style: solid;
    border-width: ${rem('6px')};
    content: ' ';
    margin-left: -${rem('6px')};
    position: absolute;
  }
  /* Position the tooltip bottom */
  ${props =>
    (props.position === 'top' &&
      css`
        bottom: 110%;
        left: 50%;
        &:after {
          top: 100%; /* At the top of the tooltip */
          left: calc(50% - 6px);
          border-color: ${props.theme.colors.secondary} transparent transparent
            transparent;
        }
      `) ||
    (props.position === 'bottom' &&
      css`
        top: 105%;
        left: 50%;
        &:after {
          bottom: 100%;
          left: 45%;
          border-color: transparent transparent ${props.theme.colors.secondary}
            transparent;
        }
      `) ||
    (props.position === 'right' &&
      css`
        top: -5px;
        left: 105%;
        &:after {
          top: 45%;
          right: 100%; /* To the left of the tooltip */
          margin-top: -${rem('5px')};
          border-color: transparent ${props.theme.colors.secondary} transparent
            transparent;
        }
      `) ||
    (props.position === 'left' &&
      css`
        top: -${rem('5px')};
        right: 105%;
        &:after {
          top: calc(50% - 6px);
          left: 100%; /* To the right of the tooltip */
          border-color: transparent transparent transparent
            ${props.theme.colors.secondary};
        }
      `)};
`;

export { StyledTooltip, StyledTooltipBasic, StyledTooltipAdvanced };
